import http from "../http/http-config";
import { CUPECheckout } from "../models/cupeCheckout";

export default new class CUPEService {

    GetCUPEUrl(productId, email): Promise<CUPECheckout> {
        return http.get<CUPECheckout>("CUPE", {
            params: {
                productId,
                email
            }
        }).then(response => response.data)
    };

    Finish(externalIdentifier,productId): Promise<boolean> {
        return http.get<boolean>("CUPE/Finish", {
            params: {
                productId,
                externalIdentifier,
            }
        }).then(response => response.data)
    };
}